interface AtsCapability {
  name: string
  capabilities: string[]
}

interface AtsProviders {
  [key: string]: AtsCapability
}

/**
 * Name and capabilities of every ATS provider TalentBridge offers, keyed by type.
 *
 * Mirrors the server's snapshot in src/atsIntegrations/atsConnectorsFallback.ts. The
 * integrations page reads the live list from GET /integrations/connectors; this copy is
 * what the lead "push to ATS" buttons check, and what that page falls back to for names.
 */
const atsProviders: AtsProviders = {
  bite: {
    name: 'BITE',
    capabilities: ['applicants:push', 'content:html', 'jobs:pull', 'setup:simple'],
  },
  carerix: {
    name: 'Carerix',
    capabilities: ['content:structured', 'content:text', 'jobs:pull', 'setup:advanced'],
  },
  'concludis-internal': {
    name: 'Concludis',
    capabilities: [
      'applicants:ats-questions',
      'applicants:push',
      'content:html',
      'content:structured',
      'content:text',
      'jobs:pull',
      'setup:simple',
    ],
  },
  coveto: {
    name: 'Coveto',
    capabilities: [
      'content:html',
      'content:structured',
      'content:text',
      'jobs:pull',
      'setup:simple',
    ],
  },
  dvinci: {
    name: 'd.vinci',
    capabilities: [
      'applicants:push',
      'content:structured',
      'content:text',
      'jobs:pull',
      'setup:simple',
    ],
  },
  factorial: {
    name: 'factorial',
    capabilities: ['content:text', 'jobs:pull', 'applicants:push', 'setup:simple'],
  },
  'generic-joblist': {
    name: 'Generic joblist',
    capabilities: [
      'content:html',
      'content:structured',
      'content:text',
      'jobs:pull',
      'jobs:push',
      'setup:advanced',
    ],
  },
  guidecom: {
    name: 'GuideCom Jobfeed',
    capabilities: ['content:structured', 'content:text', 'jobs:pull', 'setup:simple'],
  },
  hr4you: {
    name: 'HR4YOU',
    capabilities: [
      'applicants:push',
      'content:structured',
      'content:text',
      'jobs:pull',
      'setup:simple',
    ],
  },
  hrlab: {
    name: 'HRlab',
    capabilities: ['applicants:push', 'jobs:pull', 'setup:simple'],
  },
  'json-jobposting-feed': {
    name: 'JSON JobPosting Feed',
    capabilities: ['content:text', 'jobs:pull', 'setup:simple'],
  },
  karriera: {
    name: 'Karriera',
    capabilities: [
      'applicants:ats-questions',
      'applicants:push',
      'content:html',
      'content:structured',
      'content:text',
      'jobs:pull',
      'setup:simple',
    ],
  },
  onlyfy: {
    name: 'Onlyfy',
    capabilities: [
      'applicants:push',
      'content:html',
      'content:structured',
      'content:text',
      'jobs:pull',
      'setup:simple',
    ],
  },
  personio: {
    name: 'Personio',
    capabilities: [
      'applicants:push',
      'content:structured',
      'content:text',
      'jobs:pull',
      'setup:simple',
    ],
  },
  'success-factors': {
    name: 'SAP SuccessFactors',
    capabilities: ['content:structured', 'content:text', 'jobs:pull', 'setup:advanced'],
  },
  'smart-recruiters': {
    name: 'SmartRecruiters',
    capabilities: [
      'applicants:ats-questions',
      'content:structured',
      'content:text',
      'jobs:pull',
      'setup:simple',
      'applicants:push',
    ],
  },
  softgarden: {
    name: 'Softgarden',
    capabilities: ['content:text', 'jobs:pull', 'setup:simple'],
  },
  'xml-feed': {
    name: 'XML Feed',
    capabilities: [
      'content:html',
      'content:structured',
      'content:text',
      'jobs:pull',
      'setup:advanced',
    ],
  },
  'zvoove-recruit': {
    name: 'Zvoove Recruit',
    capabilities: [
      'applicants:push',
      'jobs:pull',
      'content:structured',
      'content:text',
      'setup:simple',
    ],
  },
}

export default atsProviders
